// common.types.Minutes.ts

import type { OptionalString } from './Optional';

// Minutes object. This is an example minutes object - the fields are not fixed. Each field is configurable as a simple string or as child object.
export interface Minutes extends Record<string, (string | null) | string[] | Date> {
  title: OptionalString;
  sentiment: OptionalString;
  summary: OptionalString;
  actionItems: string[];
  followUp: string[];
  arguments: string[];
  relatedTopics: string[];
  mainPoints: string[];
  stories: string[];
}

export function DefaultMinutes(): Minutes {
  return {
    title: '',
    sentiment: '',
    summary: '',
    actionItems: [],
    followUp: [],
    arguments: [],
    relatedTopics: [],
    mainPoints: [],
    stories: []
  };
}
